import React from 'react'
import { Mail } from 'lucide-react'
import { useTranslation } from '../../hooks/use-i18n'

interface Props {
  unreadCount: number
  onClick: () => void
  className?: string
}

const RoomInboxButton: React.FC<Props> = ({ unreadCount, onClick, className = '' }) => {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative p-2 sm:p-2.5 rounded-xl bg-sky-500/15 border border-sky-400/50 text-sky-400 hover:bg-sky-500/25 hover:border-sky-400/70 transition-all shrink-0 shadow-sm ${className}`}
      title={t('roomMessenger.title')}
      aria-label={t('roomMessenger.title')}
    >
      <Mail size={18} className="w-[18px] h-[18px]" />
      {unreadCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[14px] h-3.5 px-0.5 rounded-full bg-destructive text-destructive-foreground text-[9px] font-bold flex items-center justify-center">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  )
}

export default RoomInboxButton
